import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Production Firebase config
const productionConfig = {
  apiKey: "AIzaSyBVGOAq-32JH6Tnsd1MRxMxZuyXeRFP4aM",
  authDomain: "lobi-portal.firebaseapp.com",
  projectId: "lobi-portal",
  storageBucket: "lobi-portal.appspot.com",
  messagingSenderId: "606476710887",
  appId: "1:606476710887:web:0e67ee5e9c7cbcea648342",
  measurementId: "G-PBPQRS6YTN"
};

// Test project Firebase config (test-portal-lobi)
const testConfig = {
  apiKey: "AIzaSyA7znFmnhUZ1cOErXkEN4jwa1plOzL__i4",
  authDomain: "test-portal-lobi.firebaseapp.com",
  projectId: "test-portal-lobi",
  storageBucket: "test-portal-lobi.appspot.com",
  messagingSenderId: "869581673845",
  appId: "1:869581673845:web:d1dc1ce76e5d643a50af3c",
};

// Use test config when REACT_APP_USE_TEST_PROJECT=true (for E2E tests)
const USE_TEST_PROJECT = process.env.REACT_APP_USE_TEST_PROJECT === 'true';
const firebaseConfig = USE_TEST_PROJECT ? testConfig : productionConfig;

// Log which config is being used (helps diagnose CI issues)
console.log('🔧 Firebase Config:', {
  useTestProject: USE_TEST_PROJECT,
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'europe-west1');

// Force browser localStorage persistence for reliable auth in E2E tests (especially headless Chrome)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Failed to set auth persistence:', error);
});

// ===== FIREBASE EMULATOR CONFIGURATION =====
// Connect to Firebase Emulators when REACT_APP_USE_EMULATORS is set
const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';

if (USE_EMULATORS) {
  console.log('🔌 Connecting to Firebase Emulators...');

  // Connect Auth Emulator
  connectAuthEmulator(auth, 'http://localhost:9099', {
    disableWarnings: true
  });
  console.log('  ✓ Auth Emulator: http://localhost:9099');

  // Connect Firestore Emulator
  connectFirestoreEmulator(db, 'localhost', 8080);
  console.log('  ✓ Firestore Emulator: http://localhost:8080');

  // Connect Functions Emulator
  connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('  ✓ Functions Emulator: http://localhost:5001');

  // Connect Storage Emulator
  connectStorageEmulator(storage, 'localhost', 9199);
  console.log('  ✓ Storage Emulator: http://localhost:9199');

  console.log('🎯 Using Firebase Emulators - Safe for testing!');
} else {
  if (USE_TEST_PROJECT) {
    console.log('🧪 Using TEST PROJECT (test-portal-lobi) - E2E Tests');
  } else {
    console.log('🔥 Using PRODUCTION Firebase (lobi-portal)');
  }
}

export { db, storage, auth, functions };
